import Overview from './Overview'

export const contactRoutes = [
    {
      path: '/contact',
      name: 'Contact',
      component: Overview,
      meta: { requiresAuth: true, minRole: 1}
    }]


// WEBPACK FOOTER //
// ./src/CORE/modules/CONTACT/routes.js